// Generated by build/generate-palettes.js. Do not edit by hand.
import type { TonalPalette } from '../theming/palette';

export const STANDARD_PALETTES: Record<string, ReturnType<TonalPalette['colors']>> = {
  "#2563EB": [
    {
      "hue": 0,
      "hex": "#FFFFFF",
      "oklch": "oklch(100% 0 none)",
      "h": 0,
      "hScale": 0,
      "s": 0,
      "sScale": -50,
      "l": 100
    },
    {
      "hue": 50,
      "hex": "#F1F3FE",
      "oklch": "oklch(96.58% 0.01 277.91deg)",
      "h": 230.7692307692308,
      "hScale": 0,
      "s": 86.66666666666671,
      "sScale": 36.666666666666714,
      "l": 97.05882352941177
    },
    {
      "hue": 100,
      "hex": "#E0E4FD",
      "oklch": "oklch(92.34% 0.03 278.51deg)",
      "h": 231.72413793103448,
      "hScale": 0,
      "s": 87.87878787878792,
      "sScale": 37.87878787878792,
      "l": 93.52941176470588
    },
    {
      "hue": 200,
      "hex": "#C1CAFB",
      "oklch": "oklch(84.85% 0.07 276.7deg)",
      "h": 230.6896551724138,
      "hScale": 0,
      "s": 87.87878787878788,
      "sScale": 37.878787878787875,
      "l": 87.05882352941177
    },
    {
      "hue": 300,
      "hex": "#A0AFFA",
      "oklch": "oklch(77.1% 0.11 274.9deg)",
      "h": 230,
      "hScale": 0,
      "s": 90,
      "sScale": 40,
      "l": 80.3921568627451
    },
    {
      "hue": 400,
      "hex": "#7E95F8",
      "oklch": "oklch(69.56% 0.15 272.19deg)",
      "h": 228.68852459016395,
      "hScale": 0,
      "s": 89.70588235294119,
      "sScale": 39.70588235294119,
      "l": 73.33333333333334
    },
    {
      "hue": 500,
      "hex": "#567CF6",
      "oklch": "oklch(62.21% 0.19 267.67deg)",
      "h": 225.75,
      "hScale": 0,
      "s": 89.88764044943822,
      "sScale": 39.88764044943822,
      "l": 65.09803921568627
    },
    {
      "hue": 600,
      "hex": "#2563EB",
      "oklch": "oklch(54.61% 0.22 262.88deg)",
      "h": 221.21212121212122,
      "hScale": 0,
      "s": 83.19327731092436,
      "sScale": 33.19327731092436,
      "l": 53.333333333333336
    },
    {
      "hue": 700,
      "hex": "#1A4AB5",
      "oklch": "oklch(44.82% 0.18 263.01deg)",
      "h": 221.4193548387097,
      "hScale": 0,
      "s": 74.87922705314011,
      "sScale": 24.879227053140113,
      "l": 40.588235294117645
    },
    {
      "hue": 800,
      "hex": "#0F317D",
      "oklch": "oklch(34.26% 0.13 263.04deg)",
      "h": 221.45454545454547,
      "hScale": 0,
      "s": 78.57142857142857,
      "sScale": 28.57142857142857,
      "l": 27.45098039215686
    },
    {
      "hue": 900,
      "hex": "#061C4E",
      "oklch": "oklch(24.71% 0.1 262.96deg)",
      "h": 221.66666666666669,
      "hScale": 0,
      "s": 85.7142857142857,
      "sScale": 35.714285714285694,
      "l": 16.47058823529412
    },
    {
      "hue": 950,
      "hex": "#031135",
      "oklch": "oklch(19.29% 0.07 262.88deg)",
      "h": 223.20000000000002,
      "hScale": 0,
      "s": 89.2857142857143,
      "sScale": 39.285714285714306,
      "l": 10.980392156862745
    },
    {
      "hue": 1000,
      "hex": "#000000",
      "oklch": "oklch(0% 0 none)",
      "h": 0,
      "hScale": 0,
      "s": 0,
      "sScale": -50,
      "l": 0
    }
  ],
  "#EF4444": [
    {
      "hue": 0,
      "hex": "#FFFFFF",
      "oklch": "oklch(100% 0 none)",
      "h": 0,
      "hScale": 0,
      "s": 0,
      "sScale": -50,
      "l": 100
    },
    {
      "hue": 50,
      "hex": "#FDF1F1",
      "oklch": "oklch(96.75% 0.01 17.52deg)",
      "h": 0,
      "hScale": 0,
      "s": 75.00000000000009,
      "sScale": 25.000000000000085,
      "l": 96.86274509803921
    },
    {
      "hue": 100,
      "hex": "#FBE3E3",
      "oklch": "oklch(93.53% 0.03 17.7deg)",
      "h": 0,
      "hScale": 0,
      "s": 75,
      "sScale": 25,
      "l": 93.72549019607843
    },
    {
      "hue": 200,
      "hex": "#F8C9C9",
      "oklch": "oklch(87.68% 0.05 18.25deg)",
      "h": 0,
      "hScale": 0,
      "s": 77.04918032786888,
      "sScale": 27.049180327868882,
      "l": 88.0392156862745
    },
    {
      "hue": 300,
      "hex": "#F4ABAB",
      "oklch": "oklch(81.08% 0.09 19.13deg)",
      "h": 0,
      "hScale": 0,
      "s": 76.84210526315795,
      "sScale": 26.842105263157947,
      "l": 81.37254901960785
    },
    {
      "hue": 400,
      "hex": "#F29090",
      "oklch": "oklch(75.61% 0.12 20.24deg)",
      "h": 0,
      "hScale": 0,
      "s": 79.03225806451611,
      "sScale": 29.032258064516114,
      "l": 75.68627450980392
    },
    {
      "hue": 500,
      "hex": "#F06C6C",
      "oklch": "oklch(69.15% 0.16 22.3deg)",
      "h": 0,
      "hScale": 0,
      "s": 81.48148148148148,
      "sScale": 31.48148148148148,
      "l": 68.23529411764706
    },
    {
      "hue": 600,
      "hex": "#EF4444",
      "oklch": "oklch(63.69% 0.21 25.33deg)",
      "h": 0,
      "hScale": 0,
      "s": 84.23645320197043,
      "sScale": 34.236453201970434,
      "l": 60.19607843137255
    },
    {
      "hue": 700,
      "hex": "#B82828",
      "oklch": "oklch(51.31% 0.18 26.38deg)",
      "h": 0,
      "hScale": 0,
      "s": 64.28571428571429,
      "sScale": 14.285714285714292,
      "l": 43.92156862745098
    },
    {
      "hue": 800,
      "hex": "#7D1818",
      "oklch": "oklch(38.67% 0.14 26.36deg)",
      "h": 0,
      "hScale": 0,
      "s": 67.78523489932886,
      "sScale": 17.785234899328856,
      "l": 29.2156862745098
    },
    {
      "hue": 900,
      "hex": "#4B0A0A",
      "oklch": "oklch(27.04% 0.1 26.43deg)",
      "h": 0,
      "hScale": 0,
      "s": 76.4705882352941,
      "sScale": 26.4705882352941,
      "l": 16.666666666666668
    },
    {
      "hue": 950,
      "hex": "#320404",
      "oklch": "oklch(20.67% 0.07 26.7deg)",
      "h": 0,
      "hScale": 0,
      "s": 85.18518518518519,
      "sScale": 35.18518518518519,
      "l": 10.588235294117647
    },
    {
      "hue": 1000,
      "hex": "#000000",
      "oklch": "oklch(0% 0 none)",
      "h": 0,
      "hScale": 0,
      "s": 0,
      "sScale": -50,
      "l": 0
    }
  ]
};
